import { AnyAction } from 'redux';
import * as actionTypes from '../actions/story';

const initialState = {
  current: {
    loaded: false,
    error: undefined,
    data: undefined,
  },
  list: {
    loaded: false,
    error: undefined,
    data: [],
  },
  subtitles: {
    loaded: false,
    error: undefined,
    data: [],
  },
};

export default (state = initialState, action: AnyAction) => {
  switch (action.type) {
    /*  GET STORY PART  */
    case `${actionTypes.STORY_GET}:reset`: {
      return {
        ...state,
        current: {
          ...initialState.current,
        },
      };
    }
    case `${actionTypes.STORY_GET}:loading`: {
      return {
        ...state,
        current: {
          ...state.current,
          loaded: false,
          error: undefined,
        },
      };
    }
    case `${actionTypes.STORY_GET}:error`: {
      return {
        ...state,
        current: {
          ...state.current,
          loaded: true,
          error: action.payload,
        },
      };
    }
    case `${actionTypes.STORY_GET}:success`: {
      return {
        ...state,
        current: {
          ...state.current,
          data: action.payload,
          loaded: true,
          error: undefined,
        },
      };
    }

    /*  GET STORY SUBTITLES PART  */
    case `${actionTypes.STORY_SUBTITLES_GET}:reset`: {
      return {
        ...state,
        subtitles: {
          ...initialState.subtitles,
        },
      };
    }
    case `${actionTypes.STORY_SUBTITLES_GET}:loading`: {
      return {
        ...state,
        subtitles: {
          ...state.subtitles,
          loaded: false,
          error: undefined,
        },
      };
    }
    case `${actionTypes.STORY_SUBTITLES_GET}:error`: {
      return {
        ...state,
        subtitles: {
          ...state.subtitles,
          loaded: true,
          error: action.payload.message,
        },
      };
    }
    case `${actionTypes.STORY_SUBTITLES_GET}:success`: {
      return {
        ...state,
        subtitles: {
          ...state.subtitles,
          data: action.payload.data.fragments,
          loaded: true,
          error: undefined,
        },
      };
    }

    /*  STORY TOGGLE FAVORITE PART   */
    case `${actionTypes.STORY_TOGGLE_FAVORITE}:success`: {
      const data = state.current.data
        ? {
            ...(state.current.data || {}),
            liked: action.payload.data?.status === 'liked',
          }
        : undefined;

      return {
        ...state,
        current: {
          ...state.current,
          data,
          loaded: true,
          error: undefined,
        },
      };
    }
    default:
      return state;
  }
};
